<template>
  <div>
    <form-register v-model="data" @next="nextHandler"/>
  </div>
</template>

<script>
import FormRegister from "../components/FormRegister"
import ModParticipant from "../modules/ModParticipant"

export default {
  name: "ViewRegister",
  components: {
  FormRegister,
  },
  data() {
    return {
      data: ModParticipant.data,
    }
  },
  methods: {
    nextHandler(){
      this.$router.push("/vip")
    }
  },
}
</script>